import { render } from "./OrdererHint.vue?vue&type=template&id=32941cdc"
import script from "./OrdererHint.vue?vue&type=script&lang=js"
export * from "./OrdererHint.vue?vue&type=script&lang=js"

import "./OrdererHint.vue?vue&type=style&index=0&id=32941cdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__